import { faRotateBackward } from '@fortawesome/pro-light-svg-icons'
import { sellOrderStatusInversed } from '@teinor/erp/types/company/order/sell/sellOrder'
import { roundNumberAndDecimals } from '@teinor/erp/prices'
import {  ModalOpenedTy } from '../../../../../../../../../baseComponents/Modal/types'
import { ReduxRemittancePayloads, RemittanceDataTy } from '../types'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import useCollectionAndPaymentStatus from '../../../../../../../../../utils/hooks/accounting/useCollectionAndPaymentStatus'
import { ColumnOrderTableSchema } from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import { PayMCopyDateModelTypeComplete } from '../../../ModalMarkRemittanceAsPaid/ModalSelectRemittanceAsPaid/types'
import { OnSubmit } from '../../../../../../../../../forms/TwinForm/types'
import { useCallback, useEffect, useState } from 'react'
import { ModalFullCentered } from '../../../../../../../../../baseComponents/Modal'
import TwinTrans from '../../../../../../../../../baseComponents/TwinTrans'
import { CustomRenderString } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { DisplayStatus } from '../../../../../../../../../baseComponents/Displays/DisplayStatus'
import { payMCopyDateStatusInversed, PayMCopyDateStatusKeys } from '@teinor/erp/types/company/accounting/payMCopy/payMCopyDate'
import InputTableSelectPaymentMethodCopyDates from '../../../InputTableSelectPaymentMethodCopyDates'
import { DisplayPriceGettingParams } from '../../../../../../../../../baseComponents/Displays/DisplayPrice'
import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'
import ModalConfirmNewRemittance from '../ModalConfirmNewRemittance'
import TwinIcon from '../../../../../../../../../baseComponents/TwinIcon'
import NullComponent from '../../../../../../../../../baseComponents/NullComponent'
import { InputWithLabelMargin } from '../../../../../../../../../forms/Input'
import { RenderExtraPaymentDataRemittances, selectedPaymentMethodComponentsRemittance } from '../../subcomponents'
import { getISOCurrencyMain } from '../../../../../../../../../utils/reducers/getters'
import { totalCalculateParams } from '@teinor/erp/prices/quote/calculate'
import { ModalEditComponentProps } from '../../../../../../../../../baseComponents/ModalsLayouts/types'
import { twinFetchPostJSON } from '../../../../../../../../../utils/globals/data'
import LoaderDecider from '../../../../../../../../../baseComponents/LoaderDecider'
import useSelectRemittanceHook from '../../../../../../../../../utils/hooks/accounting/useSelectRemittanceHook'
import FooterSelectorTable, { FooterLeftInputTableModalComponentProps } from '../../../../../../../../../specificComponents/inputTableLayouts/FooterInputTableModalSelect'
import { addInventPositionArray } from '../../../../../../../../../utils/globals/array'

type ModalSelectNewRemittanceProps = ReduxRemittancePayloads & ModalSelectRemittanceAsPaigLogicProps & {}

const ModalSelectNewRemittance: React.FC<ModalSelectNewRemittanceProps> = ({ workingCenters, paymentMethods, paymentTypes, ...logic }) => {
    const {t} = useTwinTranslation()
    const { collectionAndPaymentStatus } = useCollectionAndPaymentStatus()
    const { resetPresearchFilterAndCompleteData, handleSubmit, handleChangeName, setCompleteData, modalOpened, setModalOpened, selectedLength, completeData } = useModalSelectRemittanceAsPaigLogic({...logic})

    const columns: ColumnOrderTableSchema<PayMCopyDateModelTypeComplete> = [
        {
            id: 'selected',
            dataKey: 'selected',
            label: '',
            simpleLabel: t('selectLine', 'Seleccionar línea'),
            width: 50,
            requiredColumn: true,
            component: 'ITCheckbox',
            headerClassName: 'checkbox_header_filter',
        },
        {
            id: 'CustomerId',
            dataKey: 'PayMCopy.Customer.name',
            label: t('customer', 'Cliente'),
            customRender: (parameterValue) => <CustomRenderString value={parameterValue} />
        },
        {
            id: 'full_assigned_number',
            dataKey: 'PayMCopy.SellInvoice.full_assigned_number',
            label: t('invoice', 'Factura'),
        },
        {
            id: 'custom_name',
            dataKey: 'PayMCopy.SellInvoice.custom_name',
            label: t('customNameShort', 'Nombre pers.'),
            simpleLabel: t('customName', 'Nombre personalizado'),
        },
        {
            id: 'BillingWorkingCenterId',
            dataKey: 'PayMCopy.BillingWorkingCenterId',
            label: t('workingCenter', 'Centro de trabajo'),
            customRender: (parameterValue) => <CustomRenderString value={workingCenters?.[parseInt(parameterValue)]?.name || ''} />
        },
        {
            id: 'date',
            dataKey: 'date',
            label: t('date', 'Fecha'),
            component: 'ITInputCalendar',
        },
        {
            id: 'status',
            dataKey: 'status',
            label: t('status', 'Estado'),
            customRender: (parameterValue) => <DisplayStatus text={collectionAndPaymentStatus[parseInt(parameterValue) as PayMCopyDateStatusKeys]?.name} colorText={collectionAndPaymentStatus[parseInt(parameterValue) as PayMCopyDateStatusKeys]?.colorText} icon={collectionAndPaymentStatus[parseInt(parameterValue) as PayMCopyDateStatusKeys]?.icon} />,
        },
        {
            id: 'quantity',
            dataKey: 'quantity',
            label: t('totalAmount', 'Importe total'),
            component: 'ITDisplayPrice',
            className: 'display_price_left'
        },
        {
            id: 'PayMCopy.name',
            dataKey: 'PayMCopy.name',
            label: t('paymentMethod', 'Método de pago'),
            customRender: (parameterValue) => <CustomRenderString value={parameterValue} />
        },
        {
            id: 'PaymentMethodId',
            dataKey: 'PayTCopy.name',
            label: t('paymentType', 'Tipo de pago'),
            customRender: (parameterValue) => <CustomRenderString value={parameterValue} />
        },
        {
            id: 'PayTCopy.new_extra_payment_data',
            dataKey: 'PayTCopy.new_extra_payment_data',
            label: t('paymentInfo', 'Información de pago'),
            customRender: (parameterValue, allRowData) => <RenderExtraPaymentDataRemittances allRowData={allRowData} />

        },
    ]

    let totalQuantity = 0
    let currencyId = getISOCurrencyMain()
    if (completeData?.selectedTableData) {
        for (const element of completeData?.selectedTableData) {
            if (completeData.tableData?.[completeData?.dictPosTableData?.[element.id]]) {
                const remittance = completeData.tableData?.[completeData?.dictPosTableData?.[element.id]]
                totalQuantity = parseFloat(remittance.quantity)
                currencyId = remittance.CurrencyId
            }
        }
    }
    totalQuantity = roundNumberAndDecimals(totalQuantity, totalCalculateParams)
    const footerLeftComponents: FooterLeftInputTableModalComponentProps[] = [
        {
            label: t('totalQuantity', 'Total cantidad'),
            children: <span className='medium14'> <DisplayPriceGettingParams value={totalQuantity} CurrencyId={currencyId} with_vat={false} /></span>
        },
        {
            label: t('lines', 'Líneas'),
            children: <span className='medium14'>{selectedLength || 0}</span>
        },
    ]

    return (
        <ModalFullCentered className='modal_select_new_remittance' opened={true} setOpened={logic.setOpened} onClickOut={false}>
            <div className='flex items-center'>
                <h2><TwinTrans transKey='newRemittance'>Nueva remesa</TwinTrans></h2>
                {completeData ? <div className='cursor-pointer text-green-21 ml-20' onClick={resetPresearchFilterAndCompleteData}><TwinIcon icon={faRotateBackward} /> <TwinTrans transKey='newSearch'>Nueva búsqueda</TwinTrans></div> : null}
            </div>
            <LoaderDecider loading={completeData === null}>
                <InputWithLabelMargin className='w-200 mt-10' label={t('nameRemittance', 'Nombre remesa')} value={completeData?.name} onChange={handleChangeName} required={true} />
                <InputTableSelectPaymentMethodCopyDates modelId={''} name='modal_select_new_remittance' className='modal_select_new_remittance' TableChildren={NullComponent} userPermissions={{ n: 1, permission: 'read' }} completeData={completeData as any} CurrencyId={completeData?.tableData?.[0]?.CurrencyId || currencyId} columns={columns} setCompleteData={setCompleteData as any} getCompleteData={async () => { }} inputTableURLs={{} as any} orderHeaderURLs={{} as any} setTableConfiguration={() => { }} tableConfiguration={{} as any} hookFunction={useSelectRemittanceHook} orderStatusDict={sellOrderStatusInversed} components={selectedPaymentMethodComponentsRemittance} {...{ paymentTypes, paymentMethods }} />
                <FooterSelectorTable setOpened={logic.setOpened} textAccept={t('save', 'Guardar')} textCancel={t('cancel', 'Cancelar')} onAccept={() => setModalOpened(true)} disabled={selectedLength === 0 || completeData?.name === ''} footerLeftComponents={footerLeftComponents} />
                {modalOpened && completeData ?
                    <ModalConfirmNewRemittance setOpened={setModalOpened} {...{ completeData, workingCenters, onSubmit: handleSubmit }} />
                    : null}
            </LoaderDecider>
        </ModalFullCentered>
    )
}

interface ModalSelectRemittanceAsPaigLogicProps extends ModalEditComponentProps {
    preSearchFilters: TwinDictionary | null
    setPreSearchFilters: React.Dispatch<React.SetStateAction<TwinDictionary | null>>
}

const useModalSelectRemittanceAsPaigLogic = ({ preSearchFilters, setPreSearchFilters, setOpened, onSubmit }: ModalSelectRemittanceAsPaigLogicProps) => {
    const [completeData, setCompleteData] = useState<RemittanceDataTy | null>(null)
    const [modalOpened, setModalOpened] = useState<ModalOpenedTy>(null)
    const selectedLength = completeData?.selectedTableData?.length || 0

    const getTableData = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/accounting/collectionAndPayments/getAllCollectionAndPayments', {
            where: {
                'PayMCopyDate.status': {
                    '$in': [payMCopyDateStatusInversed['pending_send'], payMCopyDateStatusInversed['denied']]
                },
                ...preSearchFilters
            },
            order: [['date', 'asc']],
            limit: 1000
        })
        if (result) {
            setCompleteData(() => {
                const info: RemittanceDataTy = { name: '', tableData: [], originalTableData: [], dictPosTableData: {}, selectedProducts: {}, filters: { generalSearchbar: '', order: {}, singleFieldsSearch: {} } }
                const { dictPosTableData, arrResult } = addInventPositionArray(result)
                info.tableData = arrResult
                info.originalTableData = arrResult
                info.dictPosTableData = dictPosTableData
                return info
            })
        }
    }, [setCompleteData, preSearchFilters])

    const handleChangeName = useCallback((val: string) => {
        setCompleteData((old)=>{
            const copyOld = JSON.parse(JSON.stringify(old))
            copyOld.name = val
            return copyOld
        })
    }, [setCompleteData])

    const resetPresearchFilterAndCompleteData = useCallback(() => {
        setPreSearchFilters(null)
        setCompleteData(null)
    }, [setPreSearchFilters, setCompleteData])

    const handleSubmit: OnSubmit = useCallback(async (res, values) => {
        onSubmit?.(res, values)
        setOpened(null)
    }, [setOpened, onSubmit])
    
    useEffect(() => {
        getTableData()
    }, [getTableData])

    return { resetPresearchFilterAndCompleteData, handleSubmit, handleChangeName, completeData, setCompleteData, modalOpened, setModalOpened, selectedLength }
}

export default ModalSelectNewRemittance